import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Accommodation extends Model {
  resource() {
    return 'admin/accommodations'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get typeList() {
    return this.types.map(function(obj) {
      return obj['id']
    })
  }
}
